import React, {useEffect, useLayoutEffect, useState} from "react";
import {
    AppBar,
    Box,
    useMediaQuery,
    useTheme,
    List,
    ListItem,
    ListItemText,
    Divider,
    Collapse,
    IconButton,
    Drawer, ListItemIcon
} from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Logo from "./Logo";
import HeaderRoutes from "./Tabs/HeaderTabs";
import {colorPrimary, colorWhite} from "../../constants/theme";
import MenuIcon from "@material-ui/icons/Menu";
import Dashboard from "@material-ui/icons/Dashboard";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import {Link} from "react-router-dom";
import PersonalVideoIcon from '@material-ui/icons/PersonalVideo';
import HomeIcon from "@material-ui/icons/Home";
import NotesIcon from "@material-ui/icons/Notes";
import Person from "@material-ui/icons/Person";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import MessageIcon from "@material-ui/icons/Message";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import RalphieLogo from '../../assets/RalphieLogo.png';
import {getUserProfile} from "../../redux/userProfile/userProfile.actions";
import {specialities} from "../../constants/specialities";
import {useDispatch, useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../redux/store";
import API from "../../helpers/apiHelpers"

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: "fixed",
        backgroundColor: colorWhite,
        boxShadow: "0px",
        padding: "5px 30px",
        borderBottom: "1px solid #FAFAFA",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottomColor: "#E5E6F2",
        height: "48px",
        [theme.breakpoints.down("sm")]: {
            backgroundColor: colorWhite,
            borderBottom: "1px solid #FAFAFA",
            display: "flex",
            flexDirection: "row-reverse"
        },
    },
    tabWrapper: {
        position: "relative"
    },
    toolBar: {
        minHeight: "44px"
    },
    menuIcon: {
        display: "none",
        [theme.breakpoints.down("sm")]: {
            display: "flex"
        },
    },
    logoIconWrapper: {
        display: "none",
        [theme.breakpoints.down("sm")]: {
            maxWidth: "130px",
            maxHeight: 48,
            color: "rgb(0%, 0%, 0%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        },
    },
    logIconA: {
        display: "flex",
        maxWidth: "65px",
    },
    logIcon: {
        maxHeight: 40,
        cursor: "pointer"
    },
    vettieTitle : {
        height:'36px',
        fontSize: '26px',
        color: colorPrimary,
        fontFamily: "Bogart Regular"
    },
}));
const HomePage = () => {
    const classes = useStyles();
    const dispatch = useAppDispatch();
    const [openDialog, setOpenDialog] = useState(false);
    const [open, setOpen] = React.useState(true);
    const [state, setState] = React.useState(false);
    let user = JSON.parse(localStorage.getItem("auth") || "{}");
    const [onboarded, setOnboarded] = useState(false);
    
    useEffect(() => {
        API.getSquareoauth()
            .then((res) => {
                setOnboarded(true)
            })
            .catch(() => {
                setOnboarded(false)
            });
    },[]);
    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState(open);
    };
    return (
        <>
            <AppBar className={classes.root} elevation={0} >
                <span style={{textAlign: "center", display:"table", verticalAlign:"middle"}}>
                    <IconButton edge="start" onClick={toggleDrawer(!state)} >
                        <MenuIcon />
                    </IconButton>
                    <span style={{verticalAlign: "middle"}}><img style={{width: "180px"}} src={RalphieLogo} alt={"Logo"}/></span>
                </span>
                <h2 className={classes.vettieTitle}>Vettie Portal</h2>
                <Box className={classes.tabWrapper}>
                    <HeaderRoutes.HeaderTab />
                </Box>
                <HeaderRoutes.ResponsiveTabBar open={openDialog} handleClose={setOpenDialog} />
            </AppBar>
            <Drawer
                anchor={"left"}
                open={state}
                onClose={toggleDrawer(false)}
                style={{width:'200px'}}
            >
                <div
                    onKeyDown={toggleDrawer(false)}>
                <Link to="/notificationLinks" style={{textDecoration:'none', color:'rgba(0, 0, 0, 0.54)', fontWeight: 'bold'}} className="classes.linkText">
                      <ListItem button>
                        <ListItemIcon>
                          <HomeIcon/>
                        </ListItemIcon>
                        <ListItemText className="classes.linkText" primary={"Home"}></ListItemText>
                      </ListItem>
                    </Link>
                <List>
                    {(user?.userId && !onboarded && API.isLoggedIn) && <Link to="/onboarding"  style={{textDecoration:'none', color:'rgba(0, 0, 0, 0.54)', fontWeight: 'bold'}} className="classes.linkText">
                        <ListItem button onClick={toggleDrawer(false)}>
                            <ListItemIcon>
                                <NotesIcon />
                            </ListItemIcon>
                            <ListItemText className="classes.linkText" primary={"Onboarding"}></ListItemText>
                        </ListItem>
                    </Link>}
                    {(user?.userId && API.isLoggedIn) && <Link to="/profile" style={{textDecoration:'none', color:'rgba(0, 0, 0, 0.54)', fontWeight: 'bold'}} className="classes.linkText">
                        <ListItem button onClick={toggleDrawer(false)}>
                            <ListItemIcon>
                                <Person/>
                            </ListItemIcon>
                            <ListItemText className="classes.linkText" primary={"Profile Page"}></ListItemText>
                        </ListItem>
                    </Link>}
                    {(user?.userId && API.isLoggedIn) &&
                        <>
                        <ListItem button onClick={() => setOpen(!open)}>
                            <ListItemIcon>
                                <Dashboard/>
                            </ListItemIcon>
                            <ListItemText className="classes.linkText" primary={"Resources"}></ListItemText>
                        </ListItem>
                    <Collapse in={open} timeout="auto" unmountOnExit style={{paddingLeft: "20px"}}>
                        <Link to="/resources?page=0"  style={{textDecoration:'none', color:'rgba(0, 0, 0, 0.54)', fontWeight: 'bold'}} className="classes.linkText">
                            <ListItem button onClick={toggleDrawer(false)}>
                                <ListItemIcon>
                                    <FiberManualRecord/>
                                </ListItemIcon>
                                <ListItemText className="classes.linkText" primary={"Welcome Packet"}></ListItemText>
                            </ListItem>
                        </Link>
                        <Link to="/resources?page=1"  style={{textDecoration:'none', color:'rgba(0, 0, 0, 0.54)', fontWeight: 'bold'}} className="classes.linkText">
                            <ListItem button onClick={toggleDrawer(false)}>
                                <ListItemIcon>
                                    <FiberManualRecord/>
                                </ListItemIcon>
                                <ListItemText className="classes.linkText" primary={"Working with Sling"}></ListItemText>
                            </ListItem>
                        </Link>
                        <Link to="/resources?page=2"  style={{textDecoration:'none', color:'rgba(0, 0, 0, 0.54)', fontWeight: 'bold'}} className="classes.linkText">
                            <ListItem button onClick={toggleDrawer(false)}>
                                <ListItemIcon>
                                    <FiberManualRecord/>
                                </ListItemIcon>
                                <ListItemText className="classes.linkText" primary={"Setting Up Square"}></ListItemText>
                            </ListItem>
                        </Link>
                        <Link to="/resources?page=3"  style={{textDecoration:'none', color:'rgba(0, 0, 0, 0.54)', fontWeight: 'bold'}} className="classes.linkText">
                            <ListItem button onClick={toggleDrawer(false)}>
                                <ListItemIcon>
                                    <FiberManualRecord/>
                                </ListItemIcon>
                                <ListItemText className="classes.linkText" primary={"Setting Up Your Vet Account"}></ListItemText>
                            </ListItem>
                        </Link>
                        <Link to="/resources?page=4"  style={{textDecoration:'none', color:'rgba(0, 0, 0, 0.54)', fontWeight: 'bold'}} className="classes.linkText">
                            <ListItem button onClick={toggleDrawer(false)}>
                                <ListItemIcon>
                                    <FiberManualRecord/>
                                </ListItemIcon>
                                <ListItemText className="classes.linkText" primary={"Using the Platform"}></ListItemText>
                            </ListItem>
                        </Link>
                        <Link to="/resources?page=5"  style={{textDecoration:'none', color:'rgba(0, 0, 0, 0.54)', fontWeight: 'bold'}} className="classes.linkText">
                            <ListItem button onClick={toggleDrawer(false)}>
                                <ListItemIcon>
                                    <FiberManualRecord/>
                                </ListItemIcon>
                                <ListItemText className="classes.linkText" primary={"Issuing a Refund"}></ListItemText>
                            </ListItem>
                        </Link>
                        <Link to="/resources?page=6"  style={{textDecoration:'none', color:'rgba(0, 0, 0, 0.54)', fontWeight: 'bold'}} className="classes.linkText">
                            <ListItem button onClick={toggleDrawer(false)}>
                                <ListItemIcon>
                                    <FiberManualRecord/>
                                </ListItemIcon>
                                <ListItemText className="classes.linkText" primary={"Sending an Invoice"}></ListItemText>
                            </ListItem>
                        </Link>
                        <Link to="/resources?page=7"  style={{textDecoration:'none', color:'rgba(0, 0, 0, 0.54)', fontWeight: 'bold'}} className="classes.linkText">
                            <ListItem button onClick={toggleDrawer(false)}>
                                <ListItemIcon>
                                    <FiberManualRecord/>
                                </ListItemIcon>
                                <ListItemText className="classes.linkText" primary={"Schedule a Meeting with Felicity "}></ListItemText>
                            </ListItem>
                        </Link>
                        <Link to="/handouts"  style={{textDecoration:'none', color:'rgba(0, 0, 0, 0.54)', fontWeight: 'bold'}} className="classes.linkText">
                            <ListItem button onClick={toggleDrawer(false)}>
                                <ListItemIcon>
                                    <FiberManualRecord/>
                                </ListItemIcon>
                                <ListItemText className="classes.linkText" primary={"View Handouts"}></ListItemText>
                            </ListItem>
                        </Link>
                    </Collapse>
                    </>}
                    {user?.role === "ADMIN" && <Link to="/admin"  style={{textDecoration:'none', color:'rgba(0, 0, 0, 0.54)', fontWeight: 'bold'}} className="classes.link">
                        <ListItem button onClick={toggleDrawer(false)}>
                            <ListItemIcon>
                                <SupervisorAccountIcon/>
                            </ListItemIcon>
                            <ListItemText className="classes.linkText" primary={"Admin Page"}></ListItemText>
                        </ListItem>
                    </Link>}
                    <a target="_blank" href="https://helloralphie.slack.com" rel="noreferrer" style={{textDecoration:'none', color:'rgba(0, 0, 0, 0.54)', fontWeight: 'bold'}} className="classes.link">
                        <ListItem button onClick={toggleDrawer(false)}>
                            <ListItemIcon>
                                <MessageIcon/>
                            </ListItemIcon>
                            <ListItemText className="classes.linkText" primary={"Slack"}></ListItemText>
                        </ListItem>
                    </a>
                    <a target="_blank" href="https://app.getsling.com" rel="noreferrer" style={{textDecoration:'none', color:'rgba(0, 0, 0, 0.54)', fontWeight: 'bold'}} className="classes.link">
                        <ListItem button onClick={toggleDrawer(false)}>
                            <ListItemIcon>
                                <CalendarTodayIcon/>
                            </ListItemIcon>
                            <ListItemText className="classes.linkText" primary={"View & Request Shifts"}></ListItemText>
                        </ListItem>
                    </a>
                    <a target="_blank" href="https://app.helloralphie.com/appointments" rel="noreferrer" style={{textDecoration:'none', color:'rgba(0, 0, 0, 0.54)', fontWeight: 'bold'}} className="classes.link">
                        <ListItem button onClick={toggleDrawer(false)}>
                            <ListItemIcon>
                                <PersonalVideoIcon/>
                            </ListItemIcon>
                            <ListItemText className="classes.linkText" primary={"View & Access Appointments"}></ListItemText>
                        </ListItem>
                    </a>
                </List>
                </div>
            </Drawer>
        </>
    );
};


export default HomePage;
